import type { ComputedRef } from "vue";
import type { MaybeRef } from "@vueuse/core";
import type { Customers } from "gql/api";
import type { Sizing } from "./forms/formTypes";
import { ref, computed } from "vue";
import {
  Display_Units_Enum,
  Sizing_Dispositions_Enum,
  Sizing_Pumping_Type_Enum
} from "gql/api";
import { v4 } from "uuid";
import { KUWAIT_OIL_COMPANY_ID, ECOPETROL_IDS } from "./auth/useUserInfo";

export default (
  customer?: MaybeRef<Customers | undefined>
): ComputedRef<Sizing> => {
  const _customer = ref(customer);
  const emptySizingId = v4();

  return computed<Sizing>(() => {
    let defaultCustomerID = 0;

    if (
      _customer.value?.customer_erp_id.toString() === KUWAIT_OIL_COMPANY_ID ||
      ECOPETROL_IDS.includes(_customer.value?.customer_erp_id.toString() || "")
    ) {
      defaultCustomerID = _customer.value?.id ?? 0;
    }

    return {
      __typename: "sizings",
      winning_revision_id: null,
      parent_id: null,
      customer_id: defaultCustomerID,
      well_id: 0,
      installed_scenario_id: null,
      share_with_customer: true,
      id: emptySizingId,
      title: `${new Date().toLocaleDateString()} - New Sizing`,
      is_shared: null,
      notes: "",
      default_display_units: Display_Units_Enum.UsOilField,
      disposition: Sizing_Dispositions_Enum.Unknown,
      pumping_type: Sizing_Pumping_Type_Enum.EspOnShore
    };
  });
};
